import React from 'react';

import { CommonDependency } from '@/dependency';
import { IconRcChannelFollower } from '@/assets/editor';
import { formatNum } from '@/utils';

import { Channel } from '../../types';
import style from './index.module.scss';

export const SlashOption = ({ data }: { data: Channel; search: string; prefix: '/' }) => {
  const ChannelAvatar = CommonDependency.components.ChannelAvatar;

  return (
    <div className={style.item}>
      <ChannelAvatar {...data} marginRight={14} size={28} />
      <div className={style.info}>
        <div className={style.name}>{data.id}</div>
        <div className={style.followers}>
          <IconRcChannelFollower className={style.iconFollower} />
          {formatNum(data.follower_count)} Followers
        </div>
      </div>
    </div>
  );
};
